module.exports = __webpack_public_path__ + "img/fujiwara no mokou_sc1.2150f4fd.png";